import baseTransitions from './transitionStyles/base.module.css';
import fadeTransitions from './transitionStyles/fade.module.css';
import slideDownTransitions from './transitionStyles/slide-down.module.css';
import slideUpTransitions from './transitionStyles/slide-up.module.css';
import springDownTransitions from './transitionStyles/spring-down.module.css';
import springUpTransitions from './transitionStyles/spring-up.module.css';

export default {
  springDown: {
    transitions: springDownTransitions,
    defaultOut: springUpTransitions,
    duration: 600,
  },
  springUp: {
    transitions: springUpTransitions,
    defaultOut: springDownTransitions,
    duration: 600,
  },
  slideDown: {
    transitions: slideDownTransitions,
    defaultOut: slideUpTransitions,
    duration: 300,
  },
  slideUp: {
    transitions: slideUpTransitions,
    defaultOut: slideDownTransitions,
    duration: 300,
  },
  fade: {
    transitions: fadeTransitions,
    defaultOut: fadeTransitions,
    duration: 300,
  },
  base: {
    transitions: baseTransitions,
  },
};
